import { render, staticRenderFns } from "./GoBackBtn.vue?vue&type=template&id=081a07e7"
import script from "./GoBackBtn.vue?vue&type=script&lang=js"
export * from "./GoBackBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports